import { defineStore } from "pinia";

export const useContentStore = defineStore("content", {
  state: () => ({
    contentList: window.drupalSettings?.contentToFind,
    contentType: null,
    showMapOverlay: false,
    searchedLocation: null,
    polandCenter: { lat: 52.1189046, lng: 19.1343786 },
    center: { lat: 52.1189046, lng: 19.1343786 },
    testPos: { lat: 48.1189046, lng: 19.1343786 },
    zoom: 6,
    currentBounds: null,
    contentSearched: false,
  }),
  getters: {
    getContents: (state) => state.contentList,
    getCenterPosition: (state) => state.center,
    getZoom: (state) => state.zoom,
    getCurrentBounds: (state) => state.currentBounds,
    getVisibleContents: (state) => {
      if (!state.currentBounds) {
        return [];
      }
      return state.contentList.filter(
        (content) =>
          content.position.lat > Object.values(state.currentBounds)[0].lo &&
          content.position.lat < Object.values(state.currentBounds)[0].hi &&
          content.position.lng > Object.values(state.currentBounds)[1].lo &&
          content.position.lng < Object.values(state.currentBounds)[1].hi
      );
    },
  },
  actions: {
    changeMapOverlayVisibility() {
      this.showMapOverlay = !this.showMapOverlay;
    },
    setSearchedLocation(location) {
      this.searchedLocation = location;
    },
    setCenterPosition(position) {
      this.center = position;
    },
    zoomIn() {
      this.zoom = 13;
    },
    setCurrentBounds(bounds) {
      this.currentBounds = bounds;
    },
  },
});
